/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateThread = `subscription OnCreateThread {
  onCreateThread {
    id
    name
    comments {
      items {
        id
        userId
        threadCommentThreadId
        seen
        body
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
  }
}
`;
export const onUpdateThread = `subscription OnUpdateThread {
  onUpdateThread {
    id
    name
    comments {
      items {
        id
        userId
        threadCommentThreadId
        seen
        body
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
  }
}
`;
export const onDeleteThread = `subscription OnDeleteThread {
  onDeleteThread {
    id
    name
    comments {
      items {
        id
        userId
        threadCommentThreadId
        seen
        body
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
  }
}
`;
export const onCreateThreadComment = `subscription OnCreateThreadComment {
  onCreateThreadComment {
    id
    userId
    thread {
      id
      name
      comments {
        nextToken
      }
      createdAt
    }
    threadCommentThreadId
    seen
    body
    createdAt
    updatedAt
  }
}
`;
export const onUpdateThreadComment = `subscription OnUpdateThreadComment {
  onUpdateThreadComment {
    id
    userId
    thread {
      id
      name
      comments {
        nextToken
      }
      createdAt
    }
    threadCommentThreadId
    seen
    body
    createdAt
    updatedAt
  }
}
`;
export const onDeleteThreadComment = `subscription OnDeleteThreadComment {
  onDeleteThreadComment {
    id
    userId
    thread {
      id
      name
      comments {
        nextToken
      }
      createdAt
    }
    threadCommentThreadId
    seen
    body
    createdAt
    updatedAt
  }
}
`;
export const onCreateMember = `subscription OnCreateMember {
  onCreateMember {
    id
    memberNo
    avatar {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    email
    firstName
    middleName
    lastName
    phoneNumber
    description
    status
    inactive
    manager {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    memberMembersId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    memberStoreId
    team {
      id
      name
      description
      status
      members {
        nextToken
      }
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      teamStoreId
      createdAt
      updatedAt
    }
    planResults {
      items {
        id
        checklist
        alerts
        name
        plan
        periodPlanResultPeriodId
        periodPlanResultMemberId
        targetHourLyCustomers
        actualHourLyCustomers
        targetWeeklyGp
        actualWeeklyGp
        targetWeeklyUpt
        actualWeeklyUpt
        targetWagePercent
        actualWagePercent
        createdAt
        updatedAt
      }
      nextToken
    }
    employmentType
    role {
      id
      name
      group
      precedence
      members {
        nextToken
      }
      createdAt
      updatedAt
    }
    memberRoleId
    activities {
      id
      objectReferences {
        id
        type
      }
      action
      user {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      createdAt
    }
    createdAt
    updatedAt
    photo {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    cognitoUser {
      Username
      Email
      status
    }
    ideas {
      items {
        id
        content
        status
        ideaAuthorId
        ideaStoreId
        quotable
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
`;
export const onUpdateMember = `subscription OnUpdateMember {
  onUpdateMember {
    id
    memberNo
    avatar {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    email
    firstName
    middleName
    lastName
    phoneNumber
    description
    status
    inactive
    manager {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    memberMembersId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    memberStoreId
    team {
      id
      name
      description
      status
      members {
        nextToken
      }
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      teamStoreId
      createdAt
      updatedAt
    }
    planResults {
      items {
        id
        checklist
        alerts
        name
        plan
        periodPlanResultPeriodId
        periodPlanResultMemberId
        targetHourLyCustomers
        actualHourLyCustomers
        targetWeeklyGp
        actualWeeklyGp
        targetWeeklyUpt
        actualWeeklyUpt
        targetWagePercent
        actualWagePercent
        createdAt
        updatedAt
      }
      nextToken
    }
    employmentType
    role {
      id
      name
      group
      precedence
      members {
        nextToken
      }
      createdAt
      updatedAt
    }
    memberRoleId
    activities {
      id
      objectReferences {
        id
        type
      }
      action
      user {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      createdAt
    }
    createdAt
    updatedAt
    photo {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    cognitoUser {
      Username
      Email
      status
    }
    ideas {
      items {
        id
        content
        status
        ideaAuthorId
        ideaStoreId
        quotable
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
`;
export const onDeleteMember = `subscription OnDeleteMember {
  onDeleteMember {
    id
    memberNo
    avatar {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    email
    firstName
    middleName
    lastName
    phoneNumber
    description
    status
    inactive
    manager {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    memberMembersId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    memberStoreId
    team {
      id
      name
      description
      status
      members {
        nextToken
      }
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      teamStoreId
      createdAt
      updatedAt
    }
    planResults {
      items {
        id
        checklist
        alerts
        name
        plan
        periodPlanResultPeriodId
        periodPlanResultMemberId
        targetHourLyCustomers
        actualHourLyCustomers
        targetWeeklyGp
        actualWeeklyGp
        targetWeeklyUpt
        actualWeeklyUpt
        targetWagePercent
        actualWagePercent
        createdAt
        updatedAt
      }
      nextToken
    }
    employmentType
    role {
      id
      name
      group
      precedence
      members {
        nextToken
      }
      createdAt
      updatedAt
    }
    memberRoleId
    activities {
      id
      objectReferences {
        id
        type
      }
      action
      user {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      createdAt
    }
    createdAt
    updatedAt
    photo {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    cognitoUser {
      Username
      Email
      status
    }
    ideas {
      items {
        id
        content
        status
        ideaAuthorId
        ideaStoreId
        quotable
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
`;
export const onCreateTeam = `subscription OnCreateTeam {
  onCreateTeam {
    id
    name
    description
    status
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    teamStoreId
    createdAt
    updatedAt
  }
}
`;
export const onUpdateTeam = `subscription OnUpdateTeam {
  onUpdateTeam {
    id
    name
    description
    status
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    teamStoreId
    createdAt
    updatedAt
  }
}
`;
export const onDeleteTeam = `subscription OnDeleteTeam {
  onDeleteTeam {
    id
    name
    description
    status
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    teamStoreId
    createdAt
    updatedAt
  }
}
`;
export const onCreatePeriod = `subscription OnCreatePeriod {
  onCreatePeriod {
    id
    type
    dateFrom
    dateTo
    name
    wab {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    brainBank {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    description
    planResults {
      items {
        id
        checklist
        alerts
        name
        plan
        periodPlanResultPeriodId
        periodPlanResultMemberId
        targetHourLyCustomers
        actualHourLyCustomers
        targetWeeklyGp
        actualWeeklyGp
        targetWeeklyUpt
        actualWeeklyUpt
        targetWagePercent
        actualWagePercent
        createdAt
        updatedAt
      }
      nextToken
    }
    promotions {
      items {
        id
        name
        description
        promotionPeriodId
        promotionStoreId
        type
        storeType
        storeTypes
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onUpdatePeriod = `subscription OnUpdatePeriod {
  onUpdatePeriod {
    id
    type
    dateFrom
    dateTo
    name
    wab {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    brainBank {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    description
    planResults {
      items {
        id
        checklist
        alerts
        name
        plan
        periodPlanResultPeriodId
        periodPlanResultMemberId
        targetHourLyCustomers
        actualHourLyCustomers
        targetWeeklyGp
        actualWeeklyGp
        targetWeeklyUpt
        actualWeeklyUpt
        targetWagePercent
        actualWagePercent
        createdAt
        updatedAt
      }
      nextToken
    }
    promotions {
      items {
        id
        name
        description
        promotionPeriodId
        promotionStoreId
        type
        storeType
        storeTypes
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onDeletePeriod = `subscription OnDeletePeriod {
  onDeletePeriod {
    id
    type
    dateFrom
    dateTo
    name
    wab {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    brainBank {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    description
    planResults {
      items {
        id
        checklist
        alerts
        name
        plan
        periodPlanResultPeriodId
        periodPlanResultMemberId
        targetHourLyCustomers
        actualHourLyCustomers
        targetWeeklyGp
        actualWeeklyGp
        targetWeeklyUpt
        actualWeeklyUpt
        targetWagePercent
        actualWagePercent
        createdAt
        updatedAt
      }
      nextToken
    }
    promotions {
      items {
        id
        name
        description
        promotionPeriodId
        promotionStoreId
        type
        storeType
        storeTypes
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onCreatePromotion = `subscription OnCreatePromotion {
  onCreatePromotion {
    id
    name
    description
    period {
      id
      type
      dateFrom
      dateTo
      name
      wab {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      brainBank {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      description
      planResults {
        nextToken
      }
      promotions {
        nextToken
      }
      createdAt
      updatedAt
    }
    promotionPeriodId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    promotionStoreId
    type
    files {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    storeType
    storeTypes
    createdAt
    updatedAt
  }
}
`;
export const onUpdatePromotion = `subscription OnUpdatePromotion {
  onUpdatePromotion {
    id
    name
    description
    period {
      id
      type
      dateFrom
      dateTo
      name
      wab {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      brainBank {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      description
      planResults {
        nextToken
      }
      promotions {
        nextToken
      }
      createdAt
      updatedAt
    }
    promotionPeriodId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    promotionStoreId
    type
    files {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    storeType
    storeTypes
    createdAt
    updatedAt
  }
}
`;
export const onDeletePromotion = `subscription OnDeletePromotion {
  onDeletePromotion {
    id
    name
    description
    period {
      id
      type
      dateFrom
      dateTo
      name
      wab {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      brainBank {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      description
      planResults {
        nextToken
      }
      promotions {
        nextToken
      }
      createdAt
      updatedAt
    }
    promotionPeriodId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    promotionStoreId
    type
    files {
      filename
      uploader
      uploadDate
      identityId
      userId
      hash
    }
    storeType
    storeTypes
    createdAt
    updatedAt
  }
}
`;
export const onCreatePeriodPlanResult = `subscription OnCreatePeriodPlanResult {
  onCreatePeriodPlanResult {
    id
    checklist
    alerts
    name
    plan
    managerFeedback {
      authorName
      commenter
      body
      date
    }
    period {
      id
      type
      dateFrom
      dateTo
      name
      wab {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      brainBank {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      description
      planResults {
        nextToken
      }
      promotions {
        nextToken
      }
      createdAt
      updatedAt
    }
    periodPlanResultPeriodId
    member {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    periodPlanResultMemberId
    targetHourLyCustomers
    actualHourLyCustomers
    targetWeeklyGp
    actualWeeklyGp
    targetWeeklyUpt
    actualWeeklyUpt
    targetWagePercent
    actualWagePercent
    createdAt
    updatedAt
  }
}
`;
export const onUpdatePeriodPlanResult = `subscription OnUpdatePeriodPlanResult {
  onUpdatePeriodPlanResult {
    id
    checklist
    alerts
    name
    plan
    managerFeedback {
      authorName
      commenter
      body
      date
    }
    period {
      id
      type
      dateFrom
      dateTo
      name
      wab {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      brainBank {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      description
      planResults {
        nextToken
      }
      promotions {
        nextToken
      }
      createdAt
      updatedAt
    }
    periodPlanResultPeriodId
    member {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    periodPlanResultMemberId
    targetHourLyCustomers
    actualHourLyCustomers
    targetWeeklyGp
    actualWeeklyGp
    targetWeeklyUpt
    actualWeeklyUpt
    targetWagePercent
    actualWagePercent
    createdAt
    updatedAt
  }
}
`;
export const onDeletePeriodPlanResult = `subscription OnDeletePeriodPlanResult {
  onDeletePeriodPlanResult {
    id
    checklist
    alerts
    name
    plan
    managerFeedback {
      authorName
      commenter
      body
      date
    }
    period {
      id
      type
      dateFrom
      dateTo
      name
      wab {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      brainBank {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      description
      planResults {
        nextToken
      }
      promotions {
        nextToken
      }
      createdAt
      updatedAt
    }
    periodPlanResultPeriodId
    member {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    periodPlanResultMemberId
    targetHourLyCustomers
    actualHourLyCustomers
    targetWeeklyGp
    actualWeeklyGp
    targetWeeklyUpt
    actualWeeklyUpt
    targetWagePercent
    actualWagePercent
    createdAt
    updatedAt
  }
}
`;
export const onCreateStore = `subscription OnCreateStore {
  onCreateStore {
    id
    code
    name
    type
    description
    status
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    teams {
      items {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      nextToken
    }
    promotions {
      items {
        id
        name
        description
        promotionPeriodId
        promotionStoreId
        type
        storeType
        storeTypes
        createdAt
        updatedAt
      }
      nextToken
    }
    ideas {
      items {
        id
        content
        status
        ideaAuthorId
        ideaStoreId
        quotable
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onUpdateStore = `subscription OnUpdateStore {
  onUpdateStore {
    id
    code
    name
    type
    description
    status
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    teams {
      items {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      nextToken
    }
    promotions {
      items {
        id
        name
        description
        promotionPeriodId
        promotionStoreId
        type
        storeType
        storeTypes
        createdAt
        updatedAt
      }
      nextToken
    }
    ideas {
      items {
        id
        content
        status
        ideaAuthorId
        ideaStoreId
        quotable
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onDeleteStore = `subscription OnDeleteStore {
  onDeleteStore {
    id
    code
    name
    type
    description
    status
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    teams {
      items {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      nextToken
    }
    promotions {
      items {
        id
        name
        description
        promotionPeriodId
        promotionStoreId
        type
        storeType
        storeTypes
        createdAt
        updatedAt
      }
      nextToken
    }
    ideas {
      items {
        id
        content
        status
        ideaAuthorId
        ideaStoreId
        quotable
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onCreateRole = `subscription OnCreateRole {
  onCreateRole {
    id
    name
    group
    precedence
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onUpdateRole = `subscription OnUpdateRole {
  onUpdateRole {
    id
    name
    group
    precedence
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onDeleteRole = `subscription OnDeleteRole {
  onDeleteRole {
    id
    name
    group
    precedence
    members {
      items {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
export const onCreateActivity = `subscription OnCreateActivity {
  onCreateActivity {
    id
    objectReferences {
      id
      type
    }
    action
    user {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    createdAt
  }
}
`;
export const onUpdateActivity = `subscription OnUpdateActivity {
  onUpdateActivity {
    id
    objectReferences {
      id
      type
    }
    action
    user {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    createdAt
  }
}
`;
export const onDeleteActivity = `subscription OnDeleteActivity {
  onDeleteActivity {
    id
    objectReferences {
      id
      type
    }
    action
    user {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    createdAt
  }
}
`;
export const onCreateIdea = `subscription OnCreateIdea {
  onCreateIdea {
    id
    content
    status
    author {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    ideaAuthorId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    ideaStoreId
    comment {
      authorName
      commenter
      body
      date
    }
    quotable
    createdAt
    updatedAt
  }
}
`;
export const onUpdateIdea = `subscription OnUpdateIdea {
  onUpdateIdea {
    id
    content
    status
    author {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    ideaAuthorId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    ideaStoreId
    comment {
      authorName
      commenter
      body
      date
    }
    quotable
    createdAt
    updatedAt
  }
}
`;
export const onDeleteIdea = `subscription OnDeleteIdea {
  onDeleteIdea {
    id
    content
    status
    author {
      id
      memberNo
      avatar {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      email
      firstName
      middleName
      lastName
      phoneNumber
      description
      status
      inactive
      manager {
        id
        memberNo
        email
        firstName
        middleName
        lastName
        phoneNumber
        description
        status
        inactive
        memberMembersId
        memberStoreId
        employmentType
        memberRoleId
        createdAt
        updatedAt
      }
      members {
        nextToken
      }
      memberMembersId
      store {
        id
        code
        name
        type
        description
        status
        createdAt
        updatedAt
      }
      memberStoreId
      team {
        id
        name
        description
        status
        teamStoreId
        createdAt
        updatedAt
      }
      planResults {
        nextToken
      }
      employmentType
      role {
        id
        name
        group
        precedence
        createdAt
        updatedAt
      }
      memberRoleId
      activities {
        id
        action
        createdAt
      }
      createdAt
      updatedAt
      photo {
        filename
        uploader
        uploadDate
        identityId
        userId
        hash
      }
      cognitoUser {
        Username
        Email
        status
      }
      ideas {
        nextToken
      }
    }
    ideaAuthorId
    store {
      id
      code
      name
      type
      description
      status
      members {
        nextToken
      }
      teams {
        nextToken
      }
      promotions {
        nextToken
      }
      ideas {
        nextToken
      }
      createdAt
      updatedAt
    }
    ideaStoreId
    comment {
      authorName
      commenter
      body
      date
    }
    quotable
    createdAt
    updatedAt
  }
}
`;
